const getAllFiles = () => require.context('../../../src/modules', true, /index\.js$/)


const moduleFactory = files => {
  const allFileKeys = files.keys()
  return path => {
    const modules = {}
    const resultFileKeys = path ? allFileKeys.filter(i => i.includes(`${path}/`)) : allFileKeys

    resultFileKeys.forEach(i => {
      const defaultModule = files(i)['default']
      if (typeof defaultModule === 'function' && Object.hasOwnProperty.call(defaultModule({}), 'menu')) {
        const mapList = i.split('/')
        modules[mapList.slice(1, -1).join('/')] = defaultModule
      }
    })
    return modules
  }
}

const baseModulesMixin = (cacheModuleFn, {includes, excludes}) => {
  const checkedIncludes = includes && includes.length,
    checkedExcludes = excludes && excludes.length
  if (!checkedIncludes && !checkedExcludes) return cacheModuleFn()
  let modules = {}
  if (checkedIncludes) {
    let keys = checkedExcludes ? includes.filter(i => !excludes.includes(i)) : includes
    keys.forEach(i => Object.assign(modules, cacheModuleFn(i)))
  } else {
    modules = cacheModuleFn()
    if(checkedExcludes){
      excludes.forEach(i => {
        for(let key in modules){
          key.includes(i)&&delete modules[key]
        }
      })
    }
  }
  return modules
}

const keyMapMixin = (modules, keyMap) => {
  for (const key in keyMap) {
    if (Object.prototype.hasOwnProperty.call(keyMap, key) && Object.prototype.hasOwnProperty.call(modules, key)) {
      modules[keyMap[key]] = modules[key]
      delete modules[key]
    }
  }
  return modules
}

const TYPE_OF = data => type => Object.prototype.toString.call(data) === `[object ${type}]`
/**
 *
 * @param includes {Array<String>|String|NonNullable}
 * @param excludes {Array<String>|String|NonNullable}
 * @param keyMap {Object|NonNullable}
 * @returns {{modules}}
 */
const getModules = ({includes, excludes, keyMap} = {}) => {
  const files = getAllFiles()
  let modules
  const cacheModuleFn = moduleFactory(files)

  try {
    const INCLUDES_TYPE = TYPE_OF(includes),
      EXCLUDES_TYPE = TYPE_OF(excludes)

    if (includes && !INCLUDES_TYPE('Array') && !INCLUDES_TYPE('String'))
      throw new Error('参数 includes 类型需要为 Array 或 String')
    if (includes && INCLUDES_TYPE('String')) includes = [includes]

    if (excludes && !EXCLUDES_TYPE('Array') && !EXCLUDES_TYPE('String'))
      throw new Error('参数 excludes 类型需要为 Array 或 String')
    if (excludes && EXCLUDES_TYPE('String')) excludes = [excludes]

    modules = baseModulesMixin(cacheModuleFn, {includes, excludes})
    if (keyMap && !TYPE_OF(keyMap)('Object'))
      throw new Error('参数 keyMap 类型需要为 Object')
    keyMap && (modules = keyMapMixin(modules, keyMap))
  } catch (e) {
    console.error(e)
  }
  return modules
}
export default getModules

const returnObject = (module, deep) => {
  let result = {}
  const keys = Object.keys(module).map(i => i.split('/'))
  keys.forEach(i => {
    const [key, ...path] = i
    module[key]
      ? result[key] = module[key]
      : result[key] = Object.assign(result[key] || {},
      deep && path.length > 1
        ? returnObject({[path.join('/')]: module[i.join('/')]}, deep)
        : {[path.join('/')]: module[i.join('/')]})
  })
  return result
}

/**
 *
 * @param module {Object}
 * @param deep {Boolean}
 * @returns {{module}}
 */
export const moduleToObject = ({modules = getModules(), deep = false} = {modules, deep}) => {
  return returnObject(modules, deep)
}
